import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box} from '@mui/material';
import FieldView2 from 'core/components/layout/FieldView2';


export default function CategoryInfo(){
  const { categoryObj} = useSelector((state)=>state.dmpslice.categoryDashboard);
    return (
      <Box lg={12} sx={{ flexGrow: 1 }}>
      <Grid item sx={{ overflowY: "scroll", backgroundColor: 'white', maxHeight: { xs: window.screen.height - 250, lg: window.screen.height } }}>
        
        <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        sx={{backgroundColor:'white'}}
      >
            
        <Grid item lg={4} xs={6}><FieldView2 label="Business Id"  value={ categoryObj.businessid!==null && categoryObj.businessid!==undefined?categoryObj.businessid:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Title"  value={ categoryObj.title!==null && categoryObj.title!==undefined?categoryObj.title:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Status Id"  value={ categoryObj.statusid!==null && categoryObj.statusid!==undefined?categoryObj.statusid:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Image URL"  value={ categoryObj.imageurl!==null && categoryObj.imageurl!==undefined?categoryObj.imageurl:'NOT KNONWN' }/></Grid>
      </Grid>
      </Grid>
      </Box>
    )
}